import type { SectionId } from "@/features/hr/contracts/types";
import { BasicInfoForm, PositionDutiesForm, WorkScheduleForm } from "../sections";

interface Props {
  id: SectionId;
  contractNumberError?: string;
  contractNumberEditable?: boolean;
}

const SECTION_COMPONENTS: Record<Exclude<SectionId, "basic_info">, React.FC> = {
  position_duties: PositionDutiesForm,
  work_schedule: WorkScheduleForm,
};

export default function SectionRenderer({ id, contractNumberError, contractNumberEditable }: Props) {
  if (id === "basic_info") {
    return <BasicInfoForm contractNumberError={contractNumberError} contractNumberEditable={contractNumberEditable} />;
  }
  const Component = SECTION_COMPONENTS[id];
  return <Component />;
}
